// src/utils/constants.ts
var COMPOSED_HANDLER = "__COMPOSED_HANDLER";
export {
  COMPOSED_HANDLER
};
